import _ from "lodash";

export function hasValue(value: any) {
  return !_.isNil(value) && value !== "";
}
